import type { ComponentProps } from "react";
import { Checkbox } from "@ark-ui/react";

type Props = ComponentProps<typeof Checkbox.Group>;

const Group = ({ children, ...rest }: Props) => {
  return <Checkbox.Group {...rest}>{children}</Checkbox.Group>;
};

export default Group;
